<template>
    <div id="history-index">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <!-- ======= Hero Section ======= -->
        <div id="hero-about" data-aos="zoom-out" data-aos-delay="100"></div>

        <div class="location" data-aos="fade-up" data-aos-delay="100">
            <div class="w1200 clearfix">
                <div class="left-nav">
                    <a href="/about" title="企业简介">企业简介</a>
                    <a href="/history" class="active" title="发展历程">发展历程</a>
                    <a href="/honor" title="荣誉资质">荣誉资质</a>

                </div>
            </div>
        </div>
        <div class="plat_dev">
            <div class="nap-container plat_dev_con">
                <div class="plat_dev_right">
                    <div class="section-title mt-5">
                        <h2>发展历程</h2>
                        <p> 实力决定地位，创新成就未来</p>
                    </div>
                    <div class="block">
                        <el-timeline>
                            <el-timeline-item v-for="(activity, index) in activities" :key="index" placement="top" :icon="activity.icon"
                                :type="activity.type" color="#0000ff" size="large"
                                :timestamp="activity.timestamp">
                                <el-card>
                                    <!-- <h4>{{ activity.title }}</h4> -->
                                    <p> {{ activity.content }}</p>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
            </div>

        </div>

        <!-- footer -->
        <footer-section></footer-section>
    </div>
</template>
<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
    components: {
        HeaderSection,
        FooterSection
    },
    props: {},
    data() {
        return {
            activities: [
            {
                content: '“氨氮水质在线自动分析仪”、“水质多参数(pH、DO、电导率、浊度、温度)在线自动 分析仪”和“化学需氧量（COD）在线自动分析仪”荣获“中国环境保护产品认证”证书。',
                timestamp: '2017',
            },
            {
                content: '成立北京科瑞达大环境科技股份有限公司。',
                timestamp: '2016',
            },
            {
                content: '新三板上市，正式挂牌交易，股票代码：832189。通过ISO14001环境质量体系、OHSAS18001职业健康安全管理体系认证。“DCS-8600水质多参数采集系统集成平台”荣获“河北省工业新产品”证书。被市科技局和总工会评为“市级创新型企业”。',
                timestamp: '2015',
            },
            {
                content: '大幅提升生产效率，成功开发出“电路板四维锡焊机器人阵列”。',
                timestamp: '2014',
            },
            {
                content: '2011年~2013年连续三年被高新区管委会评定为“优秀高新技术企业”。被河北省工信厅认定为“河北省软件企业”.授权组建“石家庄市水质分析仪器工程技术研究中心”，次年通过验收。 ',
                timestamp: '2013',
            },
            {
                content: '年市科技局授予董事长兼总工“石家庄市科技领军人物”的荣誉。全面实施产品质量零缺陷，同年开发出“水质在线分析仪表整机自动检定系统”。',
                timestamp: '2012',
            },
            {
                content: '被高新区管委会评为“科技创新进步企业”。',
                timestamp: '2011',
            },
            {
                content: '增资至1000万完成股改，更名为“河北科瑞达仪器科技股份有限公司”。',
                timestamp: '2010',
            },
            {
                content: '入驻高新技术开发区金石工业园，进入高科技孵化器运营。 ',
                timestamp: '2009',
            },
            {
                content: '加大科技创新投资规模，组件“科瑞达仪器北京产品研究中心”。 ',
                timestamp: '2007',
            },
            {
                content: '多数产品通过欧盟“CE”安全认证，该年实现产品出口三十多个国家。重组“河北科瑞达仪器科技有限公司”。 ',
                timestamp: '2006',
            },
            {
                content: '通过ISO9001质量管理体系认证。 ',
                timestamp: '2005',
            },
            {
                content: '被河北省科技厅认定为“高新技术企业”。 ',
                timestamp: '2003',
            },
            {
                //title: '',
                content: '河北省质量监督局授予本企业“科技创新型示范企业”资质。 ',
                timestamp: '2001',
            }, {
                content: '改组为“石家庄科达仪器仪表有限公司”，获得一般纳税人资格。 ',
                timestamp: '2000',
            }, {
                content: '组件成立“石家庄科达仪器仪表研究所”，展开市场化运营模式。',
                timestamp: '1997',
            }, {
                content: '首获国家“自动纯水监控仪”专利，跨入水质在线分析研究领域。 ',
                timestamp: '1988'
            }]
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    created() {
        //添加标题和meta标签
        let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
        document.title='发展历程-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        for(let i=0;i<m.length;i++){
            arr.some(item => {
                if(item == m[i].content){
                    m[i].remove()
                }
            })
            if(m[i].content =='发展历程'){
                m[i].remove()
            }
        }
        meta.content = '发展历程'
        
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
            if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
                m[i].remove()
            }
        }
    },
    mounted() {
    }
};
</script>
<style scoped>
#history-index{
    overflow-x: hidden;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-about {
    width: 100%;
    height: 45vh;
    background: url("~@/static/img/banner/about-banner.jpg");
    background-size: cover;
    position: relative;
}

.w1200 {
    width: 100%;
    max-width: 1200px;
    padding: 0 30px;
    margin: 0 auto;
}

.w1200-2 {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
}

.mt-5 {
    margin-top: 50px;
}

.mt-4 {
    margin-top: 50px;
}

.clearfix::after {
    display: block;
    clear: both;
    content: "";
}

/* ========= */
/*  about-us */
/* ========= */
.location {
    width: 100%;
    box-shadow: -10px -22px 30px 8px rgba(0, 0, 0, 0.5);
}

.location .left-nav {
    float: left;
}

.location .left-nav a {
    display: inline-block;
    line-height: 50px;
    font-size: 16px;
    color: #666;
    text-align: center;
    padding: 0 20px;
}

.location .left-nav a.active {
    background: #276dc1;
    color: #fff;
}

.box-shadow {
    box-shadow: 0px 30px 25px 18px rgba(0, 0, 0, 0.5);
}

.bg-lightWhite {
    background: #fefefe;
}

.text-align-center {
    text-align: center;
}

.padding-tb-30 {
    padding: 30px 0;
}

.padding-lr-30 {
    padding: 30px 0;
}

/*honor*/

.plat_dev .plat_dev_con {
    display: flex
}

.plat_dev .plat_dev_left {
    padding-top: 10px
}

.plat_dev .plat_dev_right {
    width: 100%;
    padding-left: 30px;
    padding-bottom: 40px
}

.plat_dev .plat_text1 {
    font-size: 14px;
    color: #999;
    line-height: 16px;
    margin-bottom: 30px;
    cursor: pointer;
    text-align: right
}

.plat_dev .plat_text1_focus {
    font-size: 24px;
    color: #004baa;
    line-height: 28px;
    border-bottom: 3px solid #00aff0
}

.plat_dev .plat_bottom img {
    width: 100%;
    height: 150px;
    display: block;
    -o-object-fit: cover;
    object-fit: cover
}

.plat_dev .el-timeline-cus .el-timeline-item {
    padding-bottom: 40px
}

.plat_dev .el-timeline-cus .el-timeline-item__tail {
    border-left: 4px solid #00aff0;
    left: 11px;
    opacity: .73
}

.plat_dev .el-timeline-cus .el-timeline-item__node {
    background-color: #00aff0;
    width: 32px;
    height: 32px;
    border: 6px solid #fff;
    left: -3px
}

.plat_dev .el-timeline-cus .el-timeline-item__content {
    width: 80%;
    line-height: 26px;
    margin-left: 12%;
    margin-top: -38px;
    color: #333;
    padding: 6px 12px
}

.plat_dev .el-timeline-cus .el-timeline-item__wrapper {
    margin-left: 0;
    top: 0
}

.plat_dev .el-timeline-cus .el-timeline-item__timestamp {
    display: inline-flex;
    font-size: 24px;
    color: #000;
    padding-left: 30px
}

.plat_dev .el-timeline-cus img {
    margin-top: 16px
}

.plat_dev .el-timeline-cus .date {
    font-size: 18px;
    color: #000;
    line-height: 28px;
    font-weight: 500
}

.plat_dev .el-timeline-cus .content {
    font-size: 14px;
    color: #999;
    line-height: 28px
}

.plat_dev .el-timeline-cus .nap {
    margin-top: 22px
}

.plat_dev .el-timeline-cus-bg .el-timeline-item__content {
    background: #fafafa
}

.plat_dev .el-timeline-cus-top .el-timeline-item__timestamp {
    height: 80px;
    line-height: 80px;
    display: inline-flex;
    font-size: 60px;
    border-radius: 0;
    color: #fff;
    background: #004baa;
    padding: 0 10px;
    margin-left: 30px;
    margin-top: -20px;
    margin-bottom: 60px
}

.plat_dev .el-timeline-cus-top .el-timeline-item__node {
    background-color: #fff;
    border: 6px solid #004baa
}

.plat_dev .el-timeline-cus-bottom .el-timeline-item__timestamp {
    line-height: 56px;
    display: inline-flex;
    font-size: 48px;
    color: #535353;
    margin-left: 30px;
    margin-top: -20px;
    padding-left: 0
}

.plat_dev .el-timeline-cus-bottom .el-timeline-item__node {
    background-color: #fff;
    border: 6px solid #004baa
}

.plat_dev .el-timeline-cus-bottom .el-timeline-item__content {
    background: transparent
}

@media (min-width: 1200px) and (max-width: 1340px) {
    .plat_dev .el-timeline-cus-top .el-timeline-item__timestamp {
        height: 64px;
        line-height: 64px;
        font-size: 44px
    }

    .plat_dev .el-timeline-cus-bottom .el-timeline-item__timestamp {
        line-height: 48px;
        font-size: 38px
    }
}

@media (min-width: 992px) and (max-width: 1199px) {
    .plat_dev .el-timeline-cus .el-timeline-item__content {
        margin-left: 14%
    }

    .plat_dev .el-timeline-cus-top .el-timeline-item__timestamp {
        height: 58px;
        line-height: 58px;
        font-size: 40px
    }

    .plat_dev .el-timeline-cus-bottom .el-timeline-item__timestamp {
        line-height: 48px;
        font-size: 34px
    }
}

@media (max-width: 991px) {
    .plat_dev {
        padding-top: 32px;
        padding-bottom: 24px
    }

    .plat_dev .plat_dev_left {
        padding-top: 2px
    }

    .plat_dev .plat_dev_right {
        padding-left: 14px
    }

    .plat_dev .plat_text1 {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
    }

    .plat_dev .plat_text1_focus {
        font-size: 20px;
        border-bottom: 2px solid #00aff0;
        line-height: 24px
    }

    .plat_dev .el-timeline-cus .el-timeline-item {
        padding-bottom: 32px
    }

    .plat_dev .el-timeline-cus .el-timeline-item__timestamp {
        padding-left: 0;
        font-size: 16px
    }

    .plat_dev .el-timeline-cus .el-timeline-item__tail {
        border-left: 2px solid #00aff0;
        left: 7px;
        opacity: .73
    }

    .plat_dev .el-timeline-cus .el-timeline-item__node {
        width: 22px;
        height: 22px
    }

    .plat_dev .el-timeline-cus .el-timeline-item__content {
        margin-left: 15.5%;
        padding: 8px
    }

    .plat_dev .el-timeline-cus .date {
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 8px
    }

    .plat_dev .el-timeline-cus .content {
        line-height: 22px
    }

    .plat_dev .el-timeline-cus .nap {
        margin-top: 24px
    }

    .plat_dev .el-timeline-cus img {
        min-width: 80%
    }

    .plat_dev .el-timeline-cus-top .el-timeline-item__timestamp {
        height: 36px;
        line-height: 36px;
        display: inline-flex;
        font-size: 20px;
        border-radius: 0;
        padding: 0 12px;
        margin-left: 4px;
        margin-top: -8px;
        margin-bottom: 28px
    }

    .plat_dev .el-timeline-cus-top .el-timeline-item__node {
        background-color: #fff;
        border: 6px solid #004baa
    }

    .plat_dev .el-timeline-cus-bottom .el-timeline-item__timestamp {
        line-height: 18px;
        font-size: 18px;
        color: #535353;
        margin-left: 0
    }

    .plat_dev .el-timeline-cus-nap .el-timeline-item__wrapper {
        padding-bottom: 36px !important
    }
}

@media (max-width: 768px) {
    .nap-container {
        width: 100%;
        padding: 0 16px
    }
}

@media (min-width: 768px) and (max-width: 991px) {
    .nap-container {
        width: 100%;
        padding: 0 64px
    }
}

@media (min-width: 991px) and (max-width: 1540px) {
    .nap-container {
        width: 100%;
        padding: 0 130px
    }
}

@media (min-width: 1541px) {
    .nap-container {
        width: 1200px;
        margin: 0 auto
    }
}
</style>